import React from "react";

const StatisticsPage = () => {
  return <div>StatisticsPage</div>;
};

export default StatisticsPage;
